import { render } from "./Listed.vue?vue&type=template&id=708c87a8"
import script from "./Listed.vue?vue&type=script&lang=js"
export * from "./Listed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__